import * as api from '../api';
import { FETCH_HISTORIC_NOTIFICATIONS, FETCH_MORE_HISTORIC_NOTIFICATIONS, MARK_NOTIFICATIONS_AS_READ, SHOW_NOTIFICATIONS } from '../constants/actionTypes';

export const fetchHistoricNotifications = (id, page = 1, dataPayload={}, cb) => async (dispatch) => {

    let error = null;
    let res = null;

    try {

        const {data} = await api.fetchHistoricNotifications(id, page, dataPayload);

        console.log('data: ', data);

        dispatch({
            type: page > 1 ? FETCH_MORE_HISTORIC_NOTIFICATIONS : FETCH_HISTORIC_NOTIFICATIONS,
            data
        });

        res = data; 

    } catch (err) {

        console.warn('error: ', err);

        error = err; 

    }

    if(typeof cb === 'function'){

        cb(error, res);

    }
}


export const markNotificationsAsRead = (id, notifications) => async (dispatch) => {

    try {

        const {data} = await api.markNotificationsAsRead(id, notifications);

        
        dispatch({
            type: MARK_NOTIFICATIONS_AS_READ,
            ids: notifications,
            data
        });

    } catch (err) {

        console.warn('error: ', err);
    }
}